import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() => ({
  root: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    margin: '0px',
    padding: '15px',
    borderBottom: '1px solid rgba(149, 149, 149, 0.4)',
  },
  title: {
    paddingBottom: '15px',
    marginBottom: '15px',
    borderBottom: '1px solid rgba(149, 149, 149, 0.4)',
  },
  body: {
    width: '100%',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    margin: '0px',
    padding: '0px',
  },
  fields: {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    listStyle: 'none',
    margin: '0px',
    padding: '0px 15px',
  },
  name: {
    marginBottom: '5px',
  },
  invalid: {
    color: 'red',
  },
}));

export default useStyles;
